// Tiny helper for routes that want to set <title> without going through
// PageShell's title prop (typically because the visible page heading lives
// inside a Card or other in-content element). Suffixes with " · AtlasGuess"
// to match the convention PageShell uses.
//
// Usage in a .svelte component:
//   import { withPageTitle } from '../../lib/page-title';
//   $effect(() => withPageTitle('Sign in'));

export function withPageTitle(title: string): () => void {
  if (typeof document === 'undefined') return () => {};
  const previous = document.title;
  document.title = `${title} · AtlasGuess`;
  return () => {
    document.title = previous;
  };
}
